import React from "react";
import { LogoSlider } from "./ui/logo-slider";

const brands = [
  "Retail Signage",
  "Showroom Branding",
  "Event Displays",
  "Vehicle Graphics",
  "Store Launch Kits",
  "Fabrication Works",
];

const logos = brands.map((brand) => (
  <div key={brand} className="trusted-logo-chip">
    <span className="trusted-logo-mark" aria-hidden="true" />
    <span>{brand}</span>
  </div>
));

export default function TrustedBy() {
  return (
    <section className="trusted-by-section" aria-label="Trusted by growing brands" data-testid="trusted-by-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="trusted-by-shell" data-reveal>
          <div className="trusted-by-copy">
            <span>Built For</span>
            <p>Temporary logo rail for now. We can replace each chip with your real client logos later.</p>
          </div>
          <LogoSlider logos={logos} speed={30} direction="left" />
        </div>
      </div>
    </section>
  );
}
